<template>
  <p>
    Получить микрозайм может любой гражданин РФ от 18 до 70 лет, который проживает
    <a href="pdf/География присутствия.pdf" target="_blank" class="txtLink">в зоне обслуживания</a> нашей компании.
    Необходимо наличие стабильного источника дохода, из документов нужен только паспорт.
  </p>
</template>

<script>
export default {
  name: 'txtRequirements'
}
</script>

<style scoped>
</style>